import { render, staticRenderFns } from "./gc-warning-icon.vue?vue&type=template&id=bc868a12"
import script from "./gc-warning-icon.vue?vue&type=script&lang=js"
export * from "./gc-warning-icon.vue?vue&type=script&lang=js"
import style0 from "./gc-warning-icon.vue?vue&type=style&index=0&id=bc868a12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports